import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';

import {MaterialModule} from "../../../../material.module";
import {IFilterCriteria} from "../../../../models/product-feed-options.model";

@Component({
  selector: 'app-filter-criteria',
  templateUrl: './filter-criteria.component.html',
  styleUrls: ['./filter-criteria.component.scss'],
    imports: [MaterialModule, ReactiveFormsModule],
  standalone: true
})
export class FilterCriteriaComponent implements OnInit {
    private fb = inject(FormBuilder);

  @Input() filterForm!: FormGroup; // Input from parent
  @Output() filterMappingChange = new EventEmitter<IFilterCriteria[]>(); // Output event

  operations: string[] = ['equals', "not equals"];

  ngOnInit(): void {
    if (!this.filterForm) {
      throw new Error('filterForm Input is required for FilterCriteriaComponent');
    }

    // Emit initial filter values
    this.emitFilters();

    // Subscribe to value changes in the filters FormArray to emit updates
    this.filters.valueChanges.subscribe(() => {
      this.emitFilters();
    });
  }

  // Getter to access the filters FormArray from the FormGroup
  get filters(): FormArray {
    return this.filterForm.get('filters') as FormArray;
  }

  // Method to emit the current filters
  private emitFilters(): void {
    this.filterMappingChange.emit(this.filters.value);
  }

  // Method to add a new filter
  addFilter(): void {
    this.filters.push(this.createFilter());
  }

  // Method to remove a filter at a specific index
  removeFilter(index: number): void {
    this.filters.removeAt(index);
  }

  // Helper method to create a new filter FormGroup
  private createFilter(): FormGroup {
    return this.fb.group({
      propertyName: ['', Validators.required],
      operation: ['', Validators.required],
      value: ['', Validators.required]
    });
  }
}
